$(function(){

    $('#sortBy').each(function(){
        var select = $("<select id=sortingBy></select").insertBefore($(this).hide());

        $('.inactiveTag a').each(function(){
            option = $("<option></option").appendTo(select).val(this.href).html($(this).html());
        });

        $('.activeTag a').each(function(){
            option = $("<option selected></option").appendTo(select).val(this.href).html($(this).html());
        });

        select.change(function(){
            window.location.href = this.value;
        })
    });

    $(".fader").hover(
        function () {
            $(this).stop(true,true).fadeTo('slow', 0.75);
        },
        function () {
            $(this).stop(true,true).fadeTo('fast', 1.0);
        }
    );

    //cache nav
    var nav = $("#mainNav");

    //add indicators and hovers to submenu parents
    nav.find("li").each(function() {
        if ($(this).find("ul").length > 0) {
            //show subnav on hover
            $(this).mouseenter(function() {
                $(this).find("ul").stop(true, true).fadeIn('fast');
            });

            //hide submenus on exit
            $(this).mouseleave(function() {
                $(this).find("ul").stop(true, true).fadeOut('fast');
            });
        }
    });

    $("a.group").fancybox({
        'transitionIn'  :   'elastic',
        'transitionOut' :   'elastic',
        'overlayColor'  :  '#000',
        'speedIn'       :   250,
        'speedOut'      :   100,
        'overlayShow'   :   true
    });

    if (navigator.userAgent.indexOf('iPhone') == -1) {
        $("#accountLinksWrapper").mouseenter(
            function () {
                $('#accountLink').stop(true,true).addClass('accountLinkHover');
                $('#accountLinks').stop(true,true).fadeIn();
                return false;
            }
        );
        $("#accountLinksWrapper").mouseleave(
            function () {
                $('#accountLinks').stop(true,true).fadeOut();
                $('#accountLink').stop(true,true).removeClass('accountLinkHover');
                return false;
            }
        );
    }

});